import { render, staticRenderFns } from "./showcase-revamp.vue?vue&type=template&id=47a9ac21&"
import script from "./showcase-revamp.ts?vue&type=script&lang=ts&"
export * from "./showcase-revamp.ts?vue&type=script&lang=ts&"
import style0 from "./showcase-revamp.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports